// extracted by mini-css-extract-plugin
export default {"empty":"empty-ufH8"};